/* RESPONSIBLE TEAM: team-standalone */

import type { ConversationIngestionData } from '../definitions';
import type SalesforcePlatform from '../../salesforce';

export default class SalesforceConversationIngestion implements ConversationIngestionData {
  private platform: SalesforcePlatform;

  constructor(platform: SalesforcePlatform) {
    this.platform = platform;
  }

  get drawerTitle() {
    return this.platform.intl.t('standalone.common.conversation-ingestion.salesforce-case-history');
  }

  get syncHistoryTitle() {
    return this.platform.intl.t(
      'standalone.common.conversation-ingestion.sync-conversation-history.salesforce.title',
    );
  }

  get syncTicketHistoryLabel() {
    let instanceUrl =
      this.platform.salesforceConfig?.instanceUrl ||
      this.platform.intl.t(
        'standalone.common.conversation-ingestion.sync-conversation-history.default-instance-label',
      );
    return this.platform.intl.t(
      'standalone.common.conversation-ingestion.sync-conversation-history.sync-label',
      {
        instanceUrl,
      },
    );
  }

  get disableSyncBody() {
    return this.platform.intl.t('standalone.salesforce.setup.connect.disable-sync-body');
  }

  get importingEnabledNotificationMessage() {
    return this.platform.intl.t('standalone.salesforce.setup.connect.conv-importing-enabled');
  }

  get deployCopilotRoute() {
    return 'apps.app.standalone.deploy.salesforce.copilot';
  }
}
